import angular from 'angular';

angular.module('cloudX').directive('cxEnumPickerXedit', function() {
  return {
    restrict: 'E',
    template: `<a editable-enum-picker="innerValue" onbeforesave="innerSave($data)" type="type" placeholder="placeholder" blur="submit">
  <span ng-show="displayValue" ng-bind-html="displayValue"></span>
  <i class="glyphicon glyphicon-pencil" ng-hide="displayValue"></i>
</a>`,
    scope: {
      value: '=data',
      type: '@',
      placeholder: '@?',
      save: '&',
    },
    controller: [
      '$scope',
      '$rootScope',
      '$filter',
      '$timeout',
      '$sce',
      function($scope, $rootScope, $filter, $timeout, $sce) {
        $scope.displayValue = '';
        $scope.innerValue = [];
        if (angular.isUndefined($scope.beforeSave)) $scope.beforeSave = angular.noop;

        $scope.innerSave = function(value) {
          $timeout(function() {
            $scope.save({ $data: value });
            $scope.setDisplayValue(value);
          }, 100);
        };

        $scope.setDisplayValue = function(value) {
          if (typeof value === 'string') {
            if (value.includes('[') && value.includes(']')) {
              value = JSON.parse(value).filter(x => x !== '');
            } else {
              value = value
                .replace(/\s/g, '')
                .split(',')
                .filter(x => x !== '');
            }
          }

          const otherSoftwaresThatCanSync = ['5', '29', '42', '54'];

          const html = (value || [])
            .map(x => {
              const id = typeof x === 'number' ? x.toString() : x;
              const translated = $filter('translateList')(x, $scope.type, x);
              if ($scope.type === 'othersoftware' && otherSoftwaresThatCanSync.includes(id)) {
                const tooltip = $filter('translate')('Can sync information with software');
                return `<span title="${tooltip}">${translated} <i class="fa fa-random" style="margin-left: 3px; margin-right: 1px;"></i></span>`;
              }
              return translated;
            })
            .join(', ');

          $scope.displayValue = $sce.trustAsHtml(html);
        };

        $scope.readValue = function() {
          var value = $scope.value;
          if (typeof value === 'string') {
            if (value === '') {
              value = [];
            } else {
              if (value.includes('[') && value.includes(']')) {
                value = JSON.parse(value).filter(x => x !== '');
              } else {
                value = value
                  .replace(/\s/g, '')
                  .split(',')
                  .filter(x => x !== '');
                if (value.length) {
                  value = value.map(x => parseInt(x));
                }
              }
            }
          }

          if (angular.isArray(value)) {
            $scope.innerValue = value;
          } else {
            $scope.innerValue = [];
          }
        };

        $scope.$watch(
          'value',
          function(newValue, oldValue) {
            $scope.readValue();
            $scope.setDisplayValue(newValue);
          },
          true,
        );
      },
    ],
  };
});
